import React, { ReactNode } from "react";
import {
  Draggable,
  DraggableProps,
  Droppable,
  DroppableProps,
  DroppableProvided,
  DroppableProvidedProps,
} from "react-beautiful-dnd";

type DropProps = Omit<DroppableProps, "children"> & { children: ReactNode };

export const Drop = ({ children, ...props }: DropProps) => {
  return (
    <Droppable {...props}>
      {(provided) => {
        const props = {
          ...provided.droppableProps,
          ref: provided.innerRef,
          provided,
        };
        if (React.isValidElement(children)) {
          return React.cloneElement(children, props);
        }
        return <div />;
      }}
    </Droppable>
  );
};

type DropChildProps = Partial<
  { provided: DroppableProvided } & DroppableProvidedProps
> &
  React.HTMLAttributes<HTMLDivElement>;

export const DropChild = React.forwardRef<HTMLDivElement, DropChildProps>(
  ({ children, ...props }, ref) => (
    <div {...props} ref={ref}>
      {children}
      {props.provided?.placeholder}
    </div>
  )
);

type DragProps = Omit<DraggableProps, "children"> & { children: ReactNode };

export const Drag = ({ children, ...props }: DragProps) => {
  return (
    <Draggable {...props}>
      {(provided) => {
        const props = {
          ...provided.draggableProps,
          ...provided.dragHandleProps,
          ref: provided.innerRef,
        };
        if (React.isValidElement(children)) {
          return React.cloneElement(children, props);
        }
        return <div />;
      }}
    </Draggable>
  );
};
